export default __webpack_public_path__ + "static/media/usa.c3c2932e.svg";